/** Browser entry: Matrix consumer Hydrogen shell over the typed surface protocol. */

import { startControlPlane } from './app.js';
import { isPublicPath } from './public-paths.js';

document.documentElement.dataset['theme'] = 'dark';
document.documentElement.classList.add('dark');

const root = document.getElementById('app');
if (!root) {
  throw new Error('#app root missing');
}
/*
 * A public address is drawn by a chunk of its own (`public-route.ts`), and the
 * page is blank until it is here. Waiting for it before the first draw puts
 * the page on screen once, rather than a loading card that the real page
 * replaces a moment later. A failed fetch is not fatal: the app asks for the
 * chunk again and says what happened.
 */
if (isPublicPath(window.location.pathname === '' ? '/' : window.location.pathname)) {
  await import('./public-route.js').catch(() => undefined);
}
startControlPlane(root);
